import React, { forwardRef, HTMLAttributes } from 'react';
import { css } from '@emotion/react';
import classNames from 'classnames';
import { semantic_colors } from '../../foundation';
import { CSSValueWithLength, size as sizeStyle } from '../../styles';
import { getInputFontStyle } from '../input/styles';
import { INPUT_GROUP_ADDON_CLASS_NAME } from './constants';
import { useInputGroupContext } from './InputGroupContext';
import { InputGroupSize } from './types';

export interface InputGroupAddonProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  children?: React.ReactNode;
  size?: InputGroupSize;
  disabled?: boolean;
  width?: CSSValueWithLength;
  flex?: React.CSSProperties['flex'];
}

const input_group_addon_css = css`
  display: flex;
  align-items: center;
  flex: none;
  white-space: nowrap;
  cursor: default;
`;

export const InputGroupAddon = forwardRef<HTMLDivElement, InputGroupAddonProps>(
  ({ className, size: sizeProp, disabled: disabledProp, width, flex, ...props }, ref) => {
    const group = useInputGroupContext();
    const size = sizeProp ?? group?.size ?? 'medium';
    const disabled = disabledProp ?? group?.disabled ?? false;

    return (
      <div
        className={classNames(INPUT_GROUP_ADDON_CLASS_NAME, className)}
        css={[
          input_group_addon_css,
          getInputFontStyle(size),
          sizeStyle({ width }),
          css`
            color: ${disabled ? semantic_colors.content.disabled : 'inherit'};
            ${flex !== undefined && `flex: ${flex};`}
          `,
        ]}
        ref={ref}
        {...props}
      />
    );
  },
);

InputGroupAddon.displayName = 'InputGroupAddon';
